module.exports = __webpack_public_path__ + "img/error_message_bg.d3a42553.png";